export default __webpack_public_path__ + "static/1-1-information-architecture-df24d8d10f698243733162092a9f2f0b.gif";